import { Component, Input } from '@angular/core';
import { LoadingService } from '../../services/loading/loading.service';
import { CommonModule } from '@angular/common';

export type SpinnerType = 'classic' | 'dots' | 'glassmorphism';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent {
  @Input() type: SpinnerType = 'classic';
  @Input() message: string = 'Procesando...';
  @Input() subMessage: string = 'Por favor espera un momento';
  
  isLoading = this.loader.loading$;
  
  constructor(private loader: LoadingService) {}
}